<!--title -->
<app-modal-title [title]="'pages.safeIps.confirmUserSafeIps'|translate" [isShowClose]="true" (isCloseModal)="onClose()"></app-modal-title>

<div mat-dialog-content class="dialog-content">

  <!-- form -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <div class="row">
      <div class="tw-w-full">

        <div class="row">

          <!-- useToLoginPanel -->
          <div class="sm:tw-w-1/2 tw-py-2 tw-flex tw-justify-start tw-items-center">
            <mat-slide-toggle formControlName="useToLoginPanel" [(ngModel)]="model.useToLoginPanel">
              {{ 'common.useToLoginPanel' | translate }}
            </mat-slide-toggle>
          </div>

          <!-- useToCreateToken -->
          <div class="sm:tw-w-1/2 tw-py-2 tw-flex tw-justify-start tw-items-center">
            <mat-slide-toggle formControlName="useToCreateToken" [(ngModel)]="model.useToCreateToken">
              {{ "common.useToCreateToken" | translate }}
            </mat-slide-toggle>
          </div>

        </div>
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns [loading]="loading" [form]="form" [isEdit]="formPageConfig.isEditMode" (onClose)="onClose()"
      (onSubmit)="onSubmit()">
    </app-form-btns>

  </form>
</div>
